export const INVESTIGATIONS_CAPA_PATH = "/en/services/quality-assurance/quality-compliance-remediation-capa";
export const INVESTIGATIONS_CAPA_TITLE = "Quality Compliance, Remediation & CAPA Management";
export const INVESTIGATIONS_CAPA_IMAGE =
  "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/service-images/quality-assurance/investigations-capa-management.jpg";
export const INVESTIGATIONS_CAPA_CARD = {
  title: INVESTIGATIONS_CAPA_TITLE,
  href: INVESTIGATIONS_CAPA_PATH,
  image_url: INVESTIGATIONS_CAPA_IMAGE,
  description:
    "Support across the full investigation and CAPA process, from triage of deviations, complaints and audit or inspection findings to root cause analysis, action planning, effectiveness review and backlog remediation.",
};
